import React, { Component } from "react";
import {
  Select,
  TextField,
  CardHeader,
  CardContent,
  Card,
  MenuItem,
} from "@mui/material";
import "./css/InverterSelectorForm.css";

export class SignUpEmailView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileData: this.props.profileData,
    };

    // The states array containing all the US states
    this.states = [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ];

    this.handleChange = this.handleChange.bind(this);
  }

  // Handler for the state selection dropdown
  handleChange(event) {
    this.setState(
      (prevState) => ({
        profileData: {
          ...prevState.profileData,
          [event.target.name]: event.target.value,
        },
      }),
      () => {
        this.props.setProfileData(this.state.profileData);

        if (
          this.state.profileData.Email &&
          this.state.profileData.Project &&
          this.state.profileData.FullName &&
          this.state.profileData.PhoneNumber
        ) {
          this.props.showNextButton(true);
        } else {
          //display Error here when each of the different profile data doesnt show.
        }
      }
    );
  }

  render() {
    const { profileData } = this.props;

    return (
      //App starts here
      <Card>
        <CardHeader
          titleTypographyProps={{
            fontFamily: "ford-normal",
          }}
          className="paperh-title"
          title="Sign Up"
          subheader="Note: The higher the voltage the smaller the wires and will be more cost effective to wire."
        />
        <CardContent sx={{ "& input": { fontFamily: "Ford-Normal" } }}>
          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            id="outlined-search"
            label="Project Name"
            name="Project"
            variant="filled"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.Project || ""}
          ></TextField>
          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            id="outlined-search"
            label="Electrical Designer/Engineer"
            name="EEngineer"
            variant="filled"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.EEngineer || ""}
          ></TextField>
          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            id="outlined-search"
            label="REP / Distributor"
            name="Rep"
            variant="filled"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.Rep || ""}
          ></TextField>
          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            id="outlined-search"
            label="Email"
            name="Email"
            variant="filled"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.Email}
          ></TextField>

          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            type="tel"
            label="Phone Number"
            name="PhoneNumber"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.PhoneNumber || ""}
            variant="filled"
            inputProps={{
              pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}", // Example pattern for US phone numbers
            }}
          ></TextField>

          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            type="tel"
            label="City"
            name="City"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.City || ""}
            variant="filled"
          ></TextField>

          <Select
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
              fontFamily: "Ford-Normal",
            }}
            variant="filled"
            labelId="us-state-select-label"
            id="us-state-select"
            value={profileData?.State || "CA"}
            label="State"
            name="State"
            onChange={(event) => {
              this.handleChange(event);
            }}
            //value={profileData.State || ''}
            placeholder="State"
          >
            {this.states.map((state, index) => (
              <MenuItem
                sx={{ fontFamily: "Ford-Normal" }}
                key={index}
                value={state}
              >
                {state}
              </MenuItem>
            ))}
          </Select>

          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            id="outlined-search"
            label="Company Name"
            name="CompanyName"
            variant="filled"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.CompanyName || ""}
          ></TextField>

          <TextField
            InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
            sx={{
              marginBottom: "15px",
              width: "100%",
              maxWidth: "550px",
            }}
            id="outlined-search"
            label="Full Name"
            name="FullName"
            variant="filled"
            onChange={(event) => {
              this.handleChange(event);
            }}
            value={profileData?.FullName || ""}
          ></TextField>
        </CardContent>
      </Card>
    );
  }
}

export default SignUpEmailView;
